// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"chart-area"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M12.4997 7.49957L7 12.5L7 17.2092L20 17.2092L20 6.5L15.4997 10.9996L12.4997 7.49957Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M21 21H3V3","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M12.4997 7.49957L7 12.5L7 17.2092L20 17.2092L20 6.5L15.4997 10.9996L12.4997 7.49957Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ChartAreaIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'chart-area',
    ref,
    icon: element,
  },
));

ChartAreaIcon.displayName = 'ChartAreaIcon';

export default ChartAreaIcon;
